import cn from 'classnames';
/* Class assignment */
export var itemClass = function (className, isDisabled) {
    return cn(className, 
    /* Item (base) */
    'flex cursor-pointer', 'text-label-sm', 'py-2 px-3', 'select-none', 
    /* DropdownMenu--isDisabled */
    isDisabled && 'pointer-events-none opacity-25');
};
